// Libraries
require("./libs/collections");

// Partials
require("./partials/collection/_urlToLowerCase");
// require('./partials/collection/_showProductsStickers');
require("./partials/collection/_showCampaignStickers");
require("./partials/collection/_searchList");
require("./partials/collection/_banners");

// Criteo consent banner
require("./partials/criteo/_criteoConsentCheck");
